

















































































import Vue from "vue";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
  watch,
} from "@vue/composition-api";
import { SharedState } from "@/common/state";
import AppCheckbox from "@/components/AppCheckbox.vue";
import Search from "@/components/Search.vue";
import { InformationTypeTree, InfoTypeHelper } from "@/common/models";
import { automate_state } from "../data/automate.state";
import { common_state } from "../data/common.state";
import AppDetailsCmp from "@/components/AppDetailsCmp.vue";
import { clone, emptyFn, flat_by } from "@/fp";

export default Vue.extend({
  components: { AppCheckbox, Search, AppDetailsCmp },
  props: ["l0", "value"],
  setup(props, { emit }) {
    const { get_raw_info_types_tree } = SharedState;
    const { already_mapped_cognni_labels } = automate_state;
    const query = ref("");
    //@ts-ignore
    const checked_ids = ref(props.value ? { [props.value]: true } : {});

    const filter_out_folder_label_type = (
      items: InformationTypeTree[]
    ): InformationTypeTree[] => {
      return items
        .filter((item: any) => item.labelType !== "Folder")
        .map((item) => {
          if (item.nested && item.nested.length > 0) {
            return {
              ...item,
              nested: filter_out_folder_label_type(item.nested),
            };
          }
          return item;
        });
    };

    const filter_to_mappable = (
      items: InformationTypeTree[],
      mappable_ids: Set<string>
    ): InformationTypeTree[] => {
      return items.reduce((acc, item) => {
        if (mappable_ids.has(item.id)) {
          acc.push(item);
        } else if (item.nested && item.nested.length > 0) {
          const filtered_nested = filter_to_mappable(item.nested, mappable_ids);
          if (filtered_nested.length > 0) {
            acc.push({ ...item, nested: filtered_nested });
          }
        }
        return acc;
      }, [] as InformationTypeTree[]);
    };

    const cognni_labels = computed(() => {
      const l0_id = props.l0 as string;
      let labels = filter_out_folder_label_type(
        get_raw_info_types_tree([l0_id, ""])
      );
      if (l0_id === InfoTypeHelper.REGULATED_ID()) {
        labels = labels.filter((f) => f.id !== "ms");
      }
      const mappable_ids = common_state.state.mappable_label_ids;
      if (mappable_ids.size > 0) {
        labels = filter_to_mappable(labels, mappable_ids);
      }
      return labels;
    });

    const is_searching = computed(() => query.value.length > 0);

    const possible_search_items = computed(() => {
      return flat_by<InformationTypeTree, "nested">(
        "nested",
        (l) => l
      )(clone([...cognni_labels.value], true));
    });

    const search_items = computed(() => {
      if (query.value.length > 0) {
        const reg = new RegExp(query.value, "i");
        return possible_search_items.value.filter(
          (l: any) => l.labelName.search(reg) > -1
        );
      } else {
        return [];
      }
    });

    const on_info_type_checked = (val: Record<string, boolean>) => {
      const [id] =
        (Object.entries(val).find(([key, val]) => val) as [string, boolean]) ||
        [];
      checked_ids.value = val;
      if (id) {
        emit("input", id == props.value ? "" : id);
      } else {
        emit("input", "");
      }
    };

    const current_l0 = computed(() => props.l0);

    const subs = {
      current_val_sub: emptyFn(),
    };

    onMounted(() => {
      subs.current_val_sub = watch(
        current_l0,
        (new_val, old_val) => {
          if (new_val !== old_val) {
            checked_ids.value = {};
          }
        },
        { lazy: true }
      );
    });

    onBeforeUnmount(() => {
      Object.values(subs).forEach((unsub) => unsub());
    });

    return {
      query,
      cognni_labels,
      search_items,
      possible_search_items,
      is_searching,
      already_mapped_cognni_labels,
      checked_ids,
      on_info_type_checked,
    };
  },
});
